// src/core/context/ModalContext.jsx
import React, { createContext, useContext } from 'react';
import { Modal } from 'antd';

const ModalContext = createContext({});

export const ModalProvider = ({ children }) => {
  const [modal, contextHolder] = Modal.useModal();

  return (
    <ModalContext.Provider value={modal}>
      {contextHolder}
      {children}
    </ModalContext.Provider>
  );
};

export const useModalConfirm = () => {
  const modal: any = useContext(ModalContext);
  if (!modal) {
    throw new Error('useModal must be used within a ModalProvider');
  }

  const showConfirm = (options) => {
    return modal.confirm({
      centered: false,
      maskClosable: false,
      ...options,
    });
  };

  const showInfo = (options) => {
    return modal.info({
      centered: true,
      maskClosable: false,
      ...options,
    });
  };

  const showSuccess = (options) => {
    return modal.success({
      centered: true,
      maskClosable: false,
      ...options,
    });
  };

  const showError = (options) => {
    return modal.error({
      centered: true,
      maskClosable: false,
      ...options,
    });
  };

  const showWarning = (options) => {
    return modal.warning({
      centered: true,
      maskClosable: false,
      ...options,
    });
  };

  return {
    showConfirm,
    showInfo,
    showSuccess,
    showError,
    showWarning,
  };
};
